import { render, staticRenderFns } from "./chat-message-fontes-web.vue?vue&type=template&id=6a8ce458&scoped=true&"
import script from "./chat-message-fontes-web.vue?vue&type=script&lang=js&"
export * from "./chat-message-fontes-web.vue?vue&type=script&lang=js&"
import style0 from "./chat-message-fontes-web.vue?vue&type=style&index=0&id=6a8ce458&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8ce458",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a8ce458')) {
      api.createRecord('6a8ce458', component.options)
    } else {
      api.reload('6a8ce458', component.options)
    }
    module.hot.accept("./chat-message-fontes-web.vue?vue&type=template&id=6a8ce458&scoped=true&", function () {
      api.rerender('6a8ce458', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/chat-message-fontes-web/chat-message-fontes-web.vue"
export default component.exports